/* eslint camelcase: 0 */
import common from './common/zh_CN';
import confirmation from './confirmation/zh_CN';
import dapps from './dapps/zh_CN';
import header from './header/zh_CN';
import home from './home/zh_CN';
import footer from './footer/zh_CN';
import gettingStarted from './getting-started/zh_CN';
import privacyPolicy from './privacy-policy/zh_CN';
import termsAndConditions from './terms-of-conditions/zh_CN';
import createWallet from './create-wallet/zh_CN';
import accessWallet from './access-wallet/zh_CN';
import interfaceTranslations from './interface/zh_CN';
import team from './team/zh_CN';
import popover from './popover/zh_CN';
import withoutWallet from './without-wallet/zh_CN';
import errorsGlobal from './errors-global/zh_CN';
import trezorError from './errors-trezor/zh_CN';
import ledgerError from './errors-ledger/zh_CN';
import secalotError from './errors-secalot/zh_CN';
import keepkeyError from './errors-keepkey/zh_CN';
import bitboxError from './errors-bitbox/zh_CN';

const zh_CN = {
  common: common,
  confirmation: confirmation,
  dapps: dapps,
  header: header,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfConditions: termsAndConditions,
  team: team,
  accessWallet: accessWallet,
  createWallet: createWallet,
  interface: interfaceTranslations,
  popover: popover,
  withoutWallet: withoutWallet,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  secalotError: secalotError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError
};
export default zh_CN;
